let stopScrolling = false;
  
function tocSlug(text) {
  return text.toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z ]/g, '')
    .trim()
    .replace(/\s+/g, '-');
}

function tocScanHeadings(body, selected_headings) {
  if (body === void 0) { 
    body = document.body; 
  }
  
  const headings = body.querySelectorAll(selected_headings);
  const processed = Object();
  const temp = new Array();

  headings.forEach((heading) => {
    const heading_text = heading.innerText;

    if (heading_text != '') {
      let processed_id = heading.getAttribute('id');
  
      if (!processed_id) {
        const heading_slug = tocSlug(heading_text);
        
        if (heading_slug in processed) {
          processed_id = heading_slug + '_' + ++processed[heading_slug];
        } else {
          processed_id = heading_slug;
          
          processed[processed_id] = 1;
        }
        
        heading.setAttribute('id', processed_id);
      } else {
        processed[processed_id] = 1;
      }
      
      temp.push({
        'level': parseInt(heading.tagName[1]),
        'name': heading_text,
        'id': processed_id
      });
    }
  });

  return temp;
}

function tocListItem(href, text) {
  const link = document.createElement('a');
  link.setAttribute('href', href);
  link.setAttribute('rel', 'noindex nofollow');
  link.innerHTML = text;
  
  const temp = document.createElement('li');
  temp.appendChild(link);
  
  return temp;
}

function tocList(params) {
  if (params === void 0) { 
    params = {
      'target': '',
      'body': 'body',
      'headings': 'h1,h2,h3,h4,h5,h6'
    };
  }

  const available_headings = ((params.headings != undefined && params.headings != '') ? params.headings : 'h1,h2,h3,h4,h5,h6');
  const headings = tocScanHeadings(document.querySelector(params.body), available_headings);
  const parents = [
    document.createElement('ol')
  ];
  
  let current_level = null;
  let prev_bullet = null;

  headings.forEach((heading) => {
    let current_parent = parents.slice(-1)[0];
    
    const link = tocListItem('#' + heading.id, heading.name);

    if (current_level) {
      let level_diff = heading.level - current_level;
      
      if (level_diff <= 0) {
        while (parents.length > 1 && level_diff) {
          parents.pop();
          level_diff++;
        }
      } else if (level_diff > 0) {
        while (level_diff) {
          var next_parent = document.createElement('ol');
          
          if (current_parent.innerText != '') {
            prev_bullet.appendChild(next_parent);
            current_parent.appendChild(prev_bullet);
            current_parent = next_parent;
            parents.push(next_parent);
          }
          
          level_diff--;
        }
      }
      
      current_parent = parents.slice(-1)[0];
    }

    current_level = heading.level;
    current_parent.appendChild(link);
    prev_bullet = link;
  });

  const target = document.querySelector(params.target);
  if (target != null) {
    target.appendChild(parents[0]);
    target.style.display = 'block';

    let offsetHeight = 0;
    const announcementBar = document.querySelector('.shopify-section--announcement-bar');
    const header = document.querySelector('.shopify-section--header');
    const articleNav = document.querySelector('.shopify-section--main-article .article-nav');
    
    if (announcementBar != null) {
      offsetHeight += announcementBar.offsetHeight;
    }
    if (header != null) {
      offsetHeight += header.offsetHeight;
    }
    if (articleNav != null) {
      offsetHeight += articleNav.offsetHeight;
    }

    const sidebar = document.querySelector('.article-sidebar');
    const sidebarElements = document.querySelectorAll('.article-sidebar > div:not(.article-sidebar--nav)');
    let sidebarElementsHeight = 0;
    
    sidebar.style.maxHeight = 'calc(100vh - calc(' + offsetHeight + 'px + calc(var(--spacing-10) * 2)))';
    sidebarElements.forEach((div) => {
      sidebarElementsHeight += div.offsetHeight;
    });

    const toc = sidebar.querySelector('.uplifts-article-toc');
    const tocTitle = toc.querySelector('.uplifts-article-toc-title');
    const tocContent = toc.querySelector('.uplifts-article-toc-content');

    toc.style.maxHeight = 'calc(calc(100vh - calc(' + offsetHeight + 'px + calc(var(--spacing-10) * 2))) - ' + sidebarElementsHeight + 'px)';

    let tocHeight = ((toc.offsetHeight - tocTitle.offsetHeight) - 32);
    if (toc.dataset.collapse == 'false' || (toc.dataset.collapse == 'true' && tocHeight < parseInt(toc.dataset.collapseHeight))) {
      tocContent.setAttribute('style', '--toc-height: ' + tocHeight + 'px; --toc-full-height: ' + target.offsetHeight + 'px');
    }

    window.addEventListener('resize', () => {
      tocHeight = ((toc.offsetHeight - tocTitle.offsetHeight) - 32);
      
      if (toc.dataset.collapse == 'false' || (toc.dataset.collapse == 'true' && tocHeight < parseInt(toc.dataset.collapseHeight))) {
        tocContent.removeAttribute('style');
      
        tocContent.setAttribute('style', '--toc-height: ' + ((toc.offsetHeight - tocTitle.offsetHeight) - 32) + 'px');
      }
    });
  
    const target_links = target.querySelectorAll('li a');
    if (target_links.length > 0) {
      target_links.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();

          const el = e.target;
          const id = el.getAttribute('href');
          const idHeading = document.querySelector(id);

          stopScrolling = true;

          const activeHading = target.querySelector('li a.active');
          if (activeHading != null) {
            activeHading.classList.remove('active');
          }

          el.classList.add('active');
          idHeading.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
          
          history.replaceState({}, '', id);
        });
      });
    }

    tocScrollToOnLoad(target);
    tocFocusOnScrolling(target, target_links);

    tocTitle.addEventListener('click', (e) => {
      toc.classList.toggle('uplifts-article-toc--expand');
    });
  }
}

function tocScrollToOnLoad(list) {
  const windowLocation = window.location.href.split('#');
  
  if (windowLocation[1] != undefined) {
    const articleHeading = document.querySelector('#' + windowLocation[1]);
  
    if (articleHeading != null) {
      const link = list.querySelector('a[href="#' + windowLocation[1] + '"]');
      link.classList.add('active');
      scrollParentToChild(list, link);

      stopScrolling = true;

      setTimeout(() => {
        articleHeading.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 250);
    }
  }
}

let isScrolling;
function tocFocusOnScrolling(list, listLinks) {
  const links = Array.from(listLinks);
      
  if (links.length == 0) {
    return;
  }
      
  const ids = links.map(link => link.href.split('#')[1]);
  const headings = Array.from(document.querySelectorAll(ids.map(id => `#${id}`).join(',')));
      
  if (headings.length == 0) {
    return;
  }

  document.addEventListener('scroll', () => {
    if (stopScrolling == true) {
      window.clearTimeout(isScrolling);
      
      isScrolling = setTimeout(() => {
        stopScrolling = false;
      }, 66);
      
      return;
    }
      
    let currentHeader = null;
    let currentHeaderTop = -9999;
    
    for (const heading of headings) {
      const info = heading.getBoundingClientRect();
      
      if (info.top < 150 && info.top > currentHeaderTop) {
        currentHeaderTop = info.top;
        currentHeader = heading;
      }
    }
    
    links.forEach(link => link.classList.remove('active'));
    links.forEach(link => {
      if (currentHeader && link.href.includes(`#${currentHeader.id}`)) {
        link.classList.add('active');

        scrollParentToChild(list, link);
      }
    });
  });
}

function scrollParentToChild(parent, child) {
  const parentRect = parent.getBoundingClientRect();
  const parentViewableArea = {
    height: parent.clientHeight,
    width: parent.clientWidth
  };
  const childRect = child.getBoundingClientRect();
  const isViewable = (childRect.top >= parentRect.top) && (childRect.bottom <= parentRect.top + parentViewableArea.height);

  if (!isViewable) {
    const scrollTop = childRect.top - parentRect.top;
    const scrollBot = childRect.bottom - parentRect.bottom;
    
    if (Math.abs(scrollTop) < Math.abs(scrollBot)) {
      parent.scrollTop += scrollTop;
    } else {
      parent.scrollTop += scrollBot;
    }
  }
}
